exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".time-pickr input[type=\"text\"].time-pickr-readonly {\n  width: 60px;\n  margin-left: 0;\n  margin-right: 0;\n  text-align: center; }\n\n.time-pickr .time-pickr-edit input[type=number] {\n  width: 32px;\n  padding: 0;\n  margin: 0;\n  text-align: center; }\n\n.cell-align {\n  padding-right: 0px;\n  padding-left: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-common/time-picker/time-picker.scss
// module id = /6nj
// module chunks = 0